import type {CustomerCoupon as Gift} from '~/openapi';

export enum CouponType {
	CAN_BE_ACTIVATED = 'canBeActivated',
	IS_ACTIVATED = 'isActivated',
	ONE_TIME = 'oneTime',
	SPECIFIC = 'specific',
	USED = 'used',
	PENDING = 'pending',
}

export enum GiftType {
	ACTIVE = 'active',
	PRE_ACTIVE = 'preActive',
	PENDING = 'pending',
	USED = 'used',
	INFORMATIONAL = 'informational',
}

export type GiftRuntimeCoupon = Omit<Gift['coupon'], 'Activated'> & {
	Activated?: boolean | number | string | null;
	UsedDateTime?: string | null;
};

export type GiftRuntime = Omit<Gift, 'coupon'> & {
	coupon: GiftRuntimeCoupon;
	usedDateTime?: string | null;
	UsedDateTime?: string | null;
};

export interface GiftWithType<T extends GiftType = GiftType> extends GiftRuntime {
	type: T;
}
